import api from "@/api/axiosApi";
import handleHttpError from "@/util/HttpErrorHandler";

const API_URL = `/tolls`;

const allPeages = async () => {
  try {
    const response = await api.get(API_URL);
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération des péages :', error);
    handleHttpError(error, "Impossible de récupérer les péages.");
    return [];
  }
};

export const allPeagesActive = async (active) => {
  const url = `${API_URL}/active/${active}`;

  try {
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération des péages actifs :', error);
    handleHttpError(error, "Impossible de récupérer les péages actifs.");
    return [];
  }
};

const saveToll = async (tollData) => {
  try {
    const response = await api.post(API_URL, tollData);
    return response.data;
  } catch (error) {
    console.error('Erreur lors de l\'enregistrement du péage :', error);
    handleHttpError(error, "Erreur lors de l'enregistrement du péage.");
    throw error;
  }
};

export const deleteToll = async (tollId) => {
  const url = `${API_URL}/${tollId}`;
  try {
    await api.delete(url);
  } catch (error) {
    console.error('Erreur lors de la suppression du péage :', error);
    handleHttpError(error, "Impossible de supprimer le péage.");
    throw error;
  }
};

export const getIdToll = async (tollId) => {
  const url = `${API_URL}/${tollId}`;
  try {
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération du péage :', error);
    handleHttpError(error, "Impossible de récupérer les détails du péage.");
    throw error;
  }
};

export const updateToll = async (tollId, tollData) => {
  const url = `${API_URL}/${tollId}`;
  try {
    const response = await api.put(url, tollData);
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la mise à jour du péage :', error);
    handleHttpError(error, "Impossible de mettre à jour le péage.");
    throw error;
  }
};

export const updateDisabledToll = async (tollId, tollData) => {
  const url = `${API_URL}/disabled/${tollId}`;
  try {
    const response = await api.put(url, tollData);
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la mise à jour du péage désactivé :', error);
    handleHttpError(error, "Impossible de mettre à jour le péage désactivé.");
    throw error;
  }
};

export { saveToll, allPeages };
